module.exports = __webpack_public_path__ + "img/banner3.2f9b8121.png";